

import { SET_LIST_COMPANY_TRN_DATA, SET_LIST_COMPANY_TRN_DATA_TOTAL } from "../constant/actionTypes";

const initial_state = {
    listCompanyTrnData : null,
    listCompanyTrnDataTotal: 0,
};

export default (state = initial_state, action) => {
    switch (action.type) {

        case SET_LIST_COMPANY_TRN_DATA:
            return { ...state, loading: false, listCompanyTrnData: action.listCompanyTrnData };

        case SET_LIST_COMPANY_TRN_DATA_TOTAL:
            return { ...state, loading: false, listCompanyTrnDataTotal: action.listCompanyTrnDataTotal };
            
        default: return { ...state };
    }
}
